module.exports = __webpack_public_path__ + "img/app.cb82efc5.png";